import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'create_department';
export const useCreateDepartmentTranslation = () => (
  useTranslation(namespace, { keyPrefix })
);

export const ruRu = ({
  [keyPrefix]: {
    add_button: 'Добавить',
    cancel: 'Отмена',
    fields: {
      description: 'Описание',
      name: 'Название',
    },
    submit: 'Создать',
    title: 'Новое подразделение',
    toast_error: 'Не удалось создать подразделение',
    toast_success: 'Подразделение успешно создано',
    tooltip: 'Добавить дочернее подразделение',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    add_button: 'Add',
    cancel: 'Cancel',
    fields: {
      description: 'Description',
      name: 'Name',
    },
    submit: 'Create',
    title: 'New department',
    toast_error: 'Failed to create department',
    toast_success: 'Department created successfully',
    tooltip: 'Add child department',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    add_button: 'Agregar',
    cancel: 'Cancelar',
    fields: {
      description: 'Descripción',
      name: 'Nombre',
    },
    submit: 'Crear',
    title: 'Nueva subdivisión',
    toast_error: 'No se pudo crear la subdivisión',
    toast_success: 'Subdivisión creada correctamente',
    tooltip: 'Agregar subdivisión hija',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    add_button: 'Adicionar',
    cancel: 'Cancelar',
    fields: {
      description: 'Descrição',
      name: 'Nome',
    },
    submit: 'Criar',
    title: 'Novo departamento',
    toast_error: 'Falha ao criar departamento',
    toast_success: 'Departamento criado com sucesso',
    tooltip: 'Adicionar departamento filho',
  },
}) as Record<string, unknown>;
